import { Injectable, signal } from '@angular/core';

export type DialogType = 'info' | 'success' | 'warning' | 'danger' | 'confirm' | 'custom';

export interface DialogConfig {
  type?: DialogType;
  title: string;
  message?: string;
  detail?: string;
  primaryLabel?: string;
  secondaryLabel?: string;
  onPrimary?: () => void;
  onSecondary?: () => void;
  onClose?: () => void;
}

@Injectable({ providedIn: 'root' })
export class DialogService {
  readonly config = signal<DialogConfig | null>(null);

  open(config: DialogConfig): void {
    this.config.set({ type: 'info', primaryLabel: 'OK', ...config });
  }

  info(title: string, message?: string, onPrimary?: () => void): void {
    this.open({ type: 'info', title, message, primaryLabel: 'Got it', onPrimary });
  }

  success(title: string, message?: string, onPrimary?: () => void): void {
    this.open({ type: 'success', title, message, primaryLabel: 'Done', onPrimary });
  }

  warning(title: string, message?: string, onPrimary?: () => void): void {
    this.open({ type: 'warning', title, message, primaryLabel: 'Understood', onPrimary });
  }

  danger(title: string, message?: string, onPrimary?: () => void): void {
    this.open({ type: 'danger', title, message, primaryLabel: 'Delete', secondaryLabel: 'Cancel', onPrimary });
  }

  confirm(
    title: string,
    message?: string,
    onConfirm?: () => void,
    onCancel?: () => void,
    primaryLabel = 'Confirm',
  ): void {
    this.open({
      type: 'confirm', title, message,
      primaryLabel, secondaryLabel: 'Cancel',
      onPrimary: onConfirm, onSecondary: onCancel,
    });
  }

  close(): void {
    this.config.set(null);
  }
}
